'use strict';

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};

// Polyfills - add as needed
// require('./polyfills/foreach.js');


// Script Modules
// Include as needed on your project. All scripts will be bundled together.
// Some sample files are included for ideas to get you started.

require('./custom.js');
require('./customizer.js');
require('./navigation.js');
require('./skip-link-focus-fix.js');
